import { Download } from 'lucide-react';

import { BackButton } from '@/components/atoms/BackButton';
import { Button } from '@/components/atoms/new-button';
import Pagination, { PaginationProps } from '@/components/organisms/Pagination';
import DataViewToolbar from '@/screens/Chronos/CaseEditor/DataView/components/TableToolbar';

interface Props {
  reportTitle: string;
  handleBack: () => void;
  openDownloadModal: () => void;
  goToPage: (value: number) => void;
}

export const InconsistencyReportToolbar = ({
  reportTitle,
  handleBack,
  openDownloadModal,
  canGetPrevPage,
  canGetNextPage,
  prevPage,
  nextPage,
  currentPage,
  noOfPages,
  goToPage,
}: Props & PaginationProps) => {
  return (
    <DataViewToolbar
      titleSection={
        <div className="flex items-center gap-4 pr-4">
          <BackButton onClick={handleBack} />
          <div className="font-semibold text-blue-500">{reportTitle}</div>
        </div>
      }
      actionButtons={
        <Button onClick={openDownloadModal} className="h-8 rounded-sm" variant="secondary">
          <Download className="h-3 w-3" />
          Download
        </Button>
      }
      pagination={
        <Pagination
          canGetPrevPage={canGetPrevPage}
          canGetNextPage={canGetNextPage}
          prevPage={prevPage}
          nextPage={nextPage}
          currentPage={currentPage}
          noOfPages={noOfPages}
          goToPage={goToPage}
        />
      }
    />
  );
};
